import { writable } from 'svelte/store';

export const colorCategory = writable('new_status');